export type InsightSharingAction = "sharing" | "unsharing";

export type InsightEditRequest = {
  insightId: string;
  payload: {
    is_shared: boolean;
  };
  action: InsightSharingAction;
};

export function buildInsightSharingRequest(
  insightId: string,
  isShared: boolean,
): InsightEditRequest {
  return {
    insightId,
    payload: { is_shared: isShared },
    action: isShared ? "sharing" : "unsharing",
  };
}
